import Seo from "@/components/Seo";
import Hero from "@/components/Hero";
import TrustStrip from "@/components/TrustStrip";
import Reviews from "@/components/Reviews";
import FastHighlight from "@/components/FastHighlight";
import WhyUs from "@/components/WhyUs";
import FilmsStrip from "@/components/FilmsStrip";
import MeetTheTeam from "@/components/MeetTheTeam";
import CameraShy from "@/components/CameraShy";
import Packages from "@/components/Packages";
import Venues from "@/components/Venues";
import TownsGrid from "@/components/TownsGrid";
import FAQ from "@/components/FAQ";
import { SITE, FAQS } from "@/data/site";
import { localBusinessLd, websiteLd, faqLd } from "@/lib/jsonld";
import { useLiveStats } from "@/lib/liveStats";

export default function Home() {
  const stats = useLiveStats();
  return (
    <>
      <Seo
        title={`Wedding Video Essex Reviews | ${stats.total} Five-Star Reviews | Award-Winning`}
        description={`The most-reviewed wedding videographers and photographers in Essex. ${stats.total} verified 5-star reviews across Hitched, Google, Facebook, Bridebook and Guides for Brides. 1000+ couples filmed. Essex Wedding Awards Videographer of the Year.`}
        canonical={`${SITE.url}/`}
        ogImage="https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/4tj3d52l_Helen%20%26%20Daniel%2014-07-25%20%20009.jpg"
        jsonLd={[websiteLd(), localBusinessLd(), faqLd(FAQS, stats.total)]}
      />
      <Hero />
      <TrustStrip />
      <Reviews limit={7} />
      <FastHighlight />
      <WhyUs />
      <FilmsStrip />
      <MeetTheTeam />
      <CameraShy />
      <Packages />
      <Venues />
      <TownsGrid />
      <FAQ />
    </>
  );
}
